import DefaultInput from 'components/input/DefaultInput';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
/**
 * * 플랫폼 - 재화 타입 - 대사 (bubble) 다국어 폼
 */

const CurrencyBubbleInput = ({ bubbleData, onChange }) => {
  console.log(bubbleData);
  return (
    <LocalizingForm>
      <h1>대사</h1>
      {bubbleData?.map((v) => (
        <div className='section_input'>
          <DefaultInput
            name='bubble'
            id={`${v.code}`}
            value={v.bubble}
            onChange={onChange}
            codeName={v.code_name ? v.code_name : ''}
            // maxLength={30}
            localizing
            style={{ marginLeft: '0.5rem' }}
          />
        </div>
      ))}
    </LocalizingForm>
  );
};

export default CurrencyBubbleInput;
const LocalizingForm = styled.form`
  > h1 {
    font-weight: 600;
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 1rem;
    margin-bottom: 1rem;
  }
  .section_input {
    border-bottom: 1px solid rgba(217, 222, 227, 0.5);
    margin-bottom: 2rem;
    padding-bottom: 1rem;
  }
`;
